import { useEffect } from "react";
import { fetchIdentidad } from "./actions";
import { useDispatch } from "react-redux";
import { MulticotizadorState } from "./types";

const useGetIdentidad = ({
  dniSelected,
  sexoSelected,
}: Pick<MulticotizadorState, "dniSelected" | "sexoSelected">) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (dniSelected && sexoSelected.selected)
      dispatch(fetchIdentidad(dniSelected, sexoSelected.value as string));
  }, [dispatch, dniSelected, sexoSelected]);
};

export default useGetIdentidad;
